import cls from "classnames";
import styles from "./style.module.scss";
export const ButtonState = ({ isActive }: { isActive?: boolean }) => {
  return <div className={cls(styles.btn_state, { [styles.btn_active]: isActive })}>{isActive ? "Active" : "Disabled"}</div>;
};

export default ButtonState;
